export enum IMAGE_SIZES {
  L = 'L',
  M = 'M',
  S = 'S',
}
